import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-4/5"
  >
    <vx-card>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 250px; text-align: right"
        >
          <span>Number</span>
        </div>
        <div class="column is-narrow -mt-4">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-globe"
              icon-no-border
              label-placeholder="Number"
              v-model="number"
              readonly="readonly"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
              class="column is-narrow mt-3"
              style="width: 250px; text-align: right"
            >
              <span>ผู้ประกอบการ</span>
            </div>
            <div class="column is-narrow">
              <div style="width: 300px">
                <vs-select autocomplete v-model="cmpgroupcode" class="w-full">
                  <vs-select-item
                    v-for="buss in busss"
                    :key="buss.companyGroupsCode"
                    :value="buss.companyGroupsCode"
                    :text="buss.tname"
                  />
                </vs-select>
            <p v-if="$v.cmpgroupcode.$error & $v.cmpgroupcode.$dirty">
              Please Enter Required Data with Correct Format
            </p>
              </div>
            </div>
      </div>

      <div class="columns -mb-4">
        <div
          class="column is-narrow mt-3"
          style="width: 250px; text-align: right"
        >
          <span>วันที่นำสินค้าออกจากพื้นที่ Z3</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <flat-pickr
              :config="configdateTimePicker"
              v-model="dcldate"
              placeholder="Date"
              @blur="$v.dcldate.$touch()"
            />
            <p v-if="$v.dcldate.$error & $v.dcldate.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

       <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 250px; text-align: right"
        >
          <span>Declaration No.</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-dollar-sign"
              icon-no-border
              label-placeholder="Declaration Number"
              v-model="dclnumber"
             @blur="$v.dclnumber.$touch()"
            />
            <p v-if="$v.dclnumber.$error & $v.dclnumber.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

            <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Transport Mode</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 350px">
            <vs-select autocomplete 
            @change="transSelect"
              @blur="$v.transModesId.$touch()"
            v-model="transModesId" 
            class="w-full -mt-2">
              <vs-select-item
                v-for="trans in transmode"
                :key="trans.id"
                :value="trans.id"
                :text="trans.id + '-' + trans.name"
              />
            </vs-select>
            <p v-if="$v.transModesId.$error & $v.transModesId.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

      
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 250px; text-align: right"
        >
          <span>Vessel/Aircraft</span>
        </div>
        <div class="column is-narrow -mt-4">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Vessel"
              v-model="vesselname"
              @blur="$v.vesselname.$touch()"
            />
             <p v-if="$v.vesselname.$error & $v.vesselname.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>


      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>ReleasePort</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 170px">
            <vs-input
              class="w-full -mt-2"
              icon-pack="feather"
              icon="icon-user"
              icon-no-border
              label-placeholder="Code"
              v-model="pol"
              @blur="
                $v.pol.$touch();
                onModes2();
              "
            />
            <p v-if="$v.pol.$error & $v.pol.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vx-input-group>
              <vs-input
                class="w-full -mt-2"
                icon-pack="feather"
                icon="icon-code"
                icon-no-border
                label-placeholder="ReleasePort"
                v-model="polname"
                :readonly="true"
              />

              <template slot="append">
                <div class="append-text btn-addon -mt-2">
                  <vs-button
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchRpol"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>DischargePort</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 170px">
            <vs-input
              class="w-full -mt-2"
              icon-pack="feather"
              icon="icon-user"
              icon-no-border
              label-placeholder="Code"
              v-model="pod"
              @blur="
                $v.pod.$touch();
                onModes7();
              "
            />
            <p v-if="$v.pod.$error & $v.pod.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vx-input-group>
              <vs-input
                class="w-full -mt-2"
                icon-pack="feather"
                icon="icon-code"
                icon-no-border
                label-placeholder="DischargePort"
                v-model="podname"
                :readonly="true"
              />

              <template slot="append">
                <div class="append-text btn-addon -mt-2">
                  <vs-button
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchRpol2"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
          </div>
        </div>
      </div>

      
      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Inbound Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbordersNumber"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                  @click="searchInb"
                  >ดึงข้อมูล Inbound</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

 
      <div class="columns mt-2">
        <div
          class="column is-narrow mt-3"
          style="width: 250px; text-align: right"
        >
          <span>Invoice No.</span>
        </div>
        <div class="column is-narrow -mt-3">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Invoice"
              v-model="invnum"
              :readonly="true"
            />
          </div>
        </div>
<div
          class="column is-narrow mt-4"
          style="width: 100px; text-align: right"
        >
          <span>MAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 1"
              v-model="mawb"
              @blur="$v.mawb.$touch()"
            />
            <p v-if="$v.mawb.$error & $v.mawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>

        <div
          class="column is-narrow mt-4"
          style="width: 100px; text-align: right"
        >
          <span>HAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              :readonly="true"
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 2"
              v-model="hawb"
              @blur="$v.hawb.$touch()"
            />
            <p v-if="$v.hawb.$error & $v.hawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>


      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-2/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="SKUS_Code"
            v-model="inbdetailsSkuscode"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ItemNumber"
            v-model="inbitemnum"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 -mt-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="QTY"
            @blur="$v.itemqty.$touch()"
            v-model="itemqty"
          />
        </div>
        <p v-if="$v.itemqty.$error & $v.itemqty.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="qtyunit"
          />
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Package"
            @blur="$v.itempck.$touch()"
            v-model="itempck"
          />
        </div>
        <p v-if="$v.itempck.$error & $v.itempck.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="packagesCode"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="N/W"
            @blur="$v.itemnw.$touch()"
            v-model="itemnw"
          />
        </div>
        <p v-if="$v.itemnw.$error & $v.itemnw.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="nwunit"
          />
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="G/W"
            @blur="$v.itemgw.$touch()"
            v-model="itemgw"
          />
        </div>
        <p v-if="$v.itemgw.$error & $v.itemgw.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="gwunit"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2">
        <div
          class="column is-narrow mt-4"
          style="width: 240px; text-align: right"
        >
          <span>Description</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Description"
              v-model="description"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Shipper Name</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Shipper"
              v-model="shname"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Shipper Address</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 1000px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Shipper"
              v-model="shnamea"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee Name</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Consignee"
              v-model="cnname"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee Address/Street</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 600px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Address"
              v-model="cnstreet"
            />
          </div>
        </div>
          <span class="mt-8">(ทีอยู่/ถนน)</span>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee District</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="District"
              v-model="cndist"
            />
          </div>
        </div>
          <span class="mt-8">(ตำบล)</span>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee SubProvince</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="SubProvince"
              v-model="cnsubp"
            />
          </div>
        </div>
          <span class="mt-8">(อำเภอ)</span>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>Consignee Province</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Province"
              v-model="cnprov"
            />
          </div>
        </div>
          <span class="mt-8">(จังหวัด)</span>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>ประเภท</span>
        </div>
        <div class="column is-narrow mt-2">
          <div style="width: 200px">
            <vs-select
              autocomplete
              v-model="tmotypes_code"
              disabled="disabled"
              class="w-full"
            >
              <vs-select-item
                v-for="tmotype in tmotypes"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.tmotypes_code.$error & $v.tmotypes_code.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Shipping Mark</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full -mt-2"
              icon-pack="feather"
              icon="icon-eye"
              icon-no-border
              label-placeholder="Remark"
              v-model="remark"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

        <vs-popup fullscreen title="Inbound Number" :active.sync="popupActive8">
      <inborders
        v-if="popupActive8"
        :companyGroupsCode="cmpgroupcode"
        :masrec="0"
        @recsel="recsel8"
      ></inborders>
    </vs-popup>
    <vs-popup fullscreen title="Gross Weight Unit" :active.sync="popupActive3">
      <units v-if="popupActive3" @recsel="recsel3"></units>
    </vs-popup>
    <vs-popup fullscreen title="Net Weight Unit" :active.sync="popupActive4">
      <units v-if="popupActive4" @recsel="recsel4"></units>
    </vs-popup>
    <vs-popup fullscreen title="Qty Unit" :active.sync="popupActive5">
      <units v-if="popupActive5" @recsel="recsel5"></units>
    </vs-popup>
    <vs-popup fullscreen title="Packs Unit" :active.sync="popupActive6">
      <units v-if="popupActive6" @recsel="recsel6"></units>
    </vs-popup>
    <vs-popup fullscreen title="CustomsPort" :active.sync="popupActive2">
      <customsports v-if="popupActive2" @recsel="recsel2"></customsports>
    </vs-popup>
    <vs-popup fullscreen title="CustomsPort" :active.sync="popupActive7">
      <customsports v-if="popupActive7" @recsel="recsel7"></customsports>
    </vs-popup>
  </div>
</template>

<script>
import { required,decimal } from "vuelidate/lib/validators";
import moment from "moment";
import units from "../packages/grid.vue";
import customsports from "../customsports/grid.vue";
import inborders from "./inbdetailsgrid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      cnstreet:"",
      cndist:"",
      cnsubp:"",
      cnprov:"",
      shnamea:"",
      cnnamea:"",
      shname:"",
      cnname:"",
      dest:"",
      tmotypes_code:"",
      inbdetailsSkuscode:"",
      inbitemnum:"",
      description:"",
      number:"",
      transModesId:"",
      countrys:[],
      vesselname:"",
      transmode:[],
            cmpgroupcode: "",
      busss: [],
      connumber: "",
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      pol: "1197",
      polname: "",
      pod: "",
      podname: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      dcldate: "",
      tmotypes: [],
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      popupActive5: false,
      popupActive6: false,
      popupActive7: false,
      popupActive8: false,
      nwunit: "KGM",
      gwunit: "",
      shippingmark: "",
      dclnumber: "",
      mawb: "",
      hawb: "",
      skus_code: "",
      inbordersNumber: "",
      itemnum: "",
      itemcode: "",
      edescription: "",
      tdescription: "",
      itemqty: 0,
      qtyunit: "C62",
      itemnw: 0,
      itemgw: 0,
      itempricebaht: 0,
      dutyrateincome: 0,
      dutyincome: 0,
      vatrate: 0,
      vatamount: 0,
      dutyplusvat: 0,
      remark: "",
      status: "",
      itempck: "",
      packagesCode: "",
      proTypesId: "1",
      invnum: "",
      packages: [],
      readonly: false,
    };
  },
  validations: {
    cmpgroupcode: {
      required
    },
    dcldate: {
      required,
    },
    pod: {
      required,
    },
    pol: {
      required,
    },
    transModesId: {
      required,
    },
    vesselname: {
      required,
    },
    dclnumber: {
      required,
    },
    itemqty: {
      required,
      decimal,
    },
    itempck: {
      required,
      decimal,
    },
    itemnw: {
      required,
      decimal,
    },
    itemgw: {
      required,
      decimal,
    },
    hawb: {
      required,
    },
    mawb: {
      required,
    },
    tmotypes_code: {
      required,
    },
  },
  components: {
    units,
    customsports,
    inborders
  },
  props: ["acstate", "recid"],
  methods: {
    transSelect(){
      // alert(this.transModesId);
      if(this.transModesId==3){
        this.vesselname='BY TRUCK';
      }
      else{
        this.vesselname='';
      }
    },
        searchInb() {
      // console.log("inb");
      this.popupActive8 = true;
    },
    async recsel8(val) {
      this.inbordersNumber = val;
      // console.log(this.inbordersNumber);
      this.popupActive8 = false;

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        skus_code: val,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/inbdetails/getInbDetail`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.inbordersNumber = response.data.inbordersNumber;
            this.inbitemnum = response.data.itemnum;
            this.description = response.data.edescription;
            this.itempck = response.data.itempck;
            this.packagesCode = response.data.packagesCode;
            this.itemnw = response.data.itemnw;
            this.nwunit = response.data.nwunit;
            this.itemgw = response.data.itemgw;
            this.gwunit = response.data.gwunit;
            this.itemqty = response.data.itemqty;
            this.qtyunit = response.data.qtyunit;
            this.mawb = response.data.mawb;
            this.hawb = response.data.hawb;
            this.inbdetailsSkuscode = response.data.skus_code;
            this.tmotypes_code = response.data.tmotypes_code;
       
            this.shname = response.data.shname;
            this.shnamea = response.data.shnamea;
            this.cnname = response.data.cnname;
            this.shnamea = response.data.shnamea;
            // this.cnnamea = response.data.cnnamea;
            this.invnum = response.data.invnum;

            this.cnprov = response.data.cnprov;
            this.cnsubp = response.data.cnsubp;
            this.cndist = response.data.cndist;
            this.cnstreet = response.data.cnstreet;
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    searchRpol() {
      this.popupActive2 = true;
    },
    recsel2(val) {
      // console.log(val);
      this.popupActive2 = false;
      this.pol = val;
      setTimeout(() => {
        this.onModes2();
      }, 500);
    },
    async onModes2() {
      if (this.pol == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.pol = "";
        this.polname = "";

        return;
      }

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        if (token) {
          this.popupActive2 = false;

          const response = await axios.get(
            `${BASE_API_URL}/outbound-svc/customsports/${this.pol.toUpperCase()}`,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
            this.pol = "";
            this.polname = "";
          } else {
            this.pol = response.data.code;
            this.polname = response.data.name;
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    searchRpol2() {
      this.popupActive7 = true;
    },
    recsel7(val) {
      // console.log(val);
      this.popupActive7 = false;
      this.pod = val;
      setTimeout(() => {
        this.onModes7();
      }, 500);
    },
    async onModes7() {
      if (this.pod == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.pod = "";
        this.podname = "";

        return;
      }

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        if (token) {
          this.popupActive7 = false;

          const response = await axios.get(
            `${BASE_API_URL}/outbound-svc/customsports/${this.pod.toUpperCase()}`,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
            this.pod = "";
            this.podname = "";
          } else {
            this.pod = response.data.code;
            this.podname = response.data.name;
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    recsel4(val) {
      // console.log(val);
      this.popupActive4 = false;
      this.nwunit = val;
      setTimeout(() => {
        this.onModes4();
      }, 500);
    },
    searchNwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive4 = true;
      }, 300);
    },
    async onModes4() {
      // alert("Hi");

      if (this.nwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.nwunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/outbound-svc/packages/${this.nwunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.nwunit = "";
      } else {
        this.nwunit = response4.data.code;
      }
    },
    recsel5(val) {
      // console.log(val);
      this.popupActive5 = false;
      this.qtyunit = val;
      setTimeout(() => {
        this.onModes5();
      }, 500);
    },
    searchQtyUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive5 = true;
      }, 300);
    },
    async onModes5() {
      // alert("Hi");

      if (this.qtyunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.qtyunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/outbound-svc/packages/${this.qtyunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.qtyunit = "";
      } else {
        this.qtyunit = response4.data.code;
      }
    },
    recsel3(val) {
      // console.log(val);
      this.popupActive3 = false;
      this.gwunit = val;
      setTimeout(() => {
        this.onModes3();
      }, 500);
    },
    searchGwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive3 = true;
      }, 300);
    },
    async onModes3() {
      // alert("Hi");

      if (this.gwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.gwunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/outbound-svc/packages/${this.gwunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.gwunit = "";
      } else {
        this.gwunit = response4.data.code;
      }
    },
    recsel6(val) {
      // console.log(val);
      this.popupActive6 = false;
      this.packagesCode = val;
      setTimeout(() => {
        this.onModes6();
      }, 500);
    },
    searchPacks: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive6 = true;
      }, 300);
    },
    async onModes6() {
      // alert("Hi");

      if (this.packagesCode == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.packagesCode = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/outbound-svc/packages/${this.packagesCode.toUpperCase()}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.packagesCode = "";
      } else {
        this.packagesCode = response4.data.code;
      }
    },
    clsd: function () {
      // this.skus_code = this.shippingmark = this.dclnumber = this.itemnum = this.hawb = this.mawb = this.itemcode = this.edescription = this.tdescription = this.itemqty = this.qtyunit = this.itemnw = this.itempricebaht = this.dutyrateincome = this.dutyincome = this.vatrate = this.vatamount = this.remark = this.itempck = this.packagesCode = this.invnum = this.shname = this.shtax = this.shbranch = this.shnamea = this.shstreet = this.shdist = this.shsubp = this.shprov = this.shpostc = this.cnname = this.cntax = this.cnbranch = this.cnnamea = this.cnstreet = this.cndist = this.cnsubp = this.cnprov = this.cnpostc = this.cncountry =
      //   "";
      let vm = this;
      vm.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      this.$v.$touch();
      // alert("Hi");
      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } 

      if (this.dclnumber.length!=14) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Error",
          text: "Declaration No ไม่ใช่ 14 หลัก",
        });
        return;
      } 
      // else if (this.itempck == 0) {
      //   // alert("Please Enter The Informaiton");
      //   this.$vs.notify({
      //     position: "top-right",
      //     color: "danger",
      //     title: "Package can't Zero",
      //     text: "กรุณาระบุจำนวน Package",
      //   });
      //   return;
      // } 
      // else if (
      //   (this.mawb == "" || null) &&
      //   (this.hawb == "" || null) &&
      //   (this.invnum == "" || null) &&
      //   (this.dclnumber == "" || null)
      // ) 
      // {
      //   // alert("Please Enter The Informaiton");
      //   this.$vs.notify({
      //     position: "top-right",
      //     color: "danger",
      //     title: "Information Missing",
      //     text: "กรุณาระบุ บัญชีราคาสินค้า หรือ ใบขนสินค้าขาออก หรือ เลขที่ใบตราส่งสินค้า 1,2 ",
      //   });
      //   return;
      // }

      const formData = {
        number: this.recid,
        companyGroupsCode: this.cmpgroupcode,
        dcldate: this.dcldate,
        transModesId: this.transModesId,
        vesselname: this.vesselname,
        pol: this.pol,
        pod: this.pod,
        acstate: this.acstate,
        businessPartnersCode: this.cmpgroupcode,
        exbordersNumber: this.recid,
        invnum: this.invnum,
        itemnum: this.itemnum,
        inbordersNumber: this.inbordersNumber,
        inbitemnum: this.inbitemnum,
        itemqty: this.itemqty,
        remark: this.remark,
        inbdetailsSkuscode: this.inbdetailsSkuscode,
        mawb: this.mawb,
        hawb: this.hawb,
        dclnumber: this.dclnumber,
        repdate: this.dcldate,
        shname: this.shname,
        shnamea: this.shnamea,
        cnname: this.cnname,
        editor: String(this.userid),
        connumber: this.connumber,
        itempck: this.itempck,
        itemnw: this.itemnw,
        cnstreet: this.cnstreet,
        cndist: this.cndist,
        cnsubp: this.cnsubp,
        cnprov: this.cnprov,
        cnnamea: this.cnname+" "+this.cnstreet+" "+this.cndist+" "+this.cnprov,
      };

      // console.log(formData);

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/cpermits/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    const formData = {
      searchval: "",
      inbfrom: "DOM",
    };

    // const response4 = await axios.post(
    //   `${BASE_API_URL}/inbound-svc/tmotypes/getTmotypes`,
    //   formData,
    //   {
    //     headers: { Authorization: "Bearer " + token.accessToken },
    //   }
    // );

    // if (!response4.data) {
    //   this.loading = false;
    //   this.$vs.notify({
    //     position: "top-right",
    //     color: "danger",
    //     title: "Error from Backend",
    //     text: response4.data.message,
    //   });
    // } else {
    //   this.tmotypes = response4.data;
    // }

    const response6 = await axios.post(
      `${BASE_API_URL}/outbound-svc/tmotypes/getTmotypesALL`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response6.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response6.data.message,
      });
    } else {
      this.tmotypes = response6.data;
    }



    // console.log(this.$route.params.id);
  },
  async created() {
    this.checkProfiles();
    // console.log(this.recid);
    // console.log(this.masrec);
    // console.log('created')
    try {
      const formData = {
        searchval: "",
        // inbfrom: this.inbfrom,
      };
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response3 = await axios.post(
        `${BASE_API_URL}/auth-svc/businesspartners/getBusinessPartnersDTO`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response3.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response3.data.message,
        });
      } else {
       for(let element of response3.data){
        this.busss.push(element)
       }       
      }

          const response4 = await axios.post(
      `${BASE_API_URL}/outbound-svc/transmodes/getTransmodes`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response4.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response4.data.message,
      });
    } else {
      this.transmode = response4.data;
    }

    } catch (error) {
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }

    // this.inbordersNumber = this.masrec;

    if (this.recid != "0") {

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
       const response = await axios.get(
          `${BASE_API_URL}/outbound-svc/cpermits/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
            this.number = response.data.exborders.number;
            this.cmpgroupcode =
              response.data.exborders.businessPartnersCode;
            this.dcldate = response.data.exborders.dcldate;
            this.transModesId = response.data.exborders.transModesId;
            this.vesselname = response.data.exborders.vesselname;
            this.remark = response.data.exborders.remark;
            this.status = response.data.exborders.status;
            this.pol = response.data.exborders.pol;
            this.pod = response.data.exborders.pod;
            this.dclnumber = response.data.exbdetail.dclnumber;
            this.remark = response.data.exbdetail.remark;
          setTimeout(() => {
            this.onModes2();
            this.onModes7();
            this.recsel8(response.data.skus_code);
          }, 500);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();

      setTimeout(() => {
        this.gwunit = "KGM";
            this.onModes2();
      }, 300);
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
